export default "__VITE_ASSET__CUX3v$wi__"